import classes from "./GlowingCircle.module.css";

const GlowingCircle = ({ children, style, className }) => {
  return <div className={`${classes.glowingCircle} ${className}`} style={style}>{children}</div>;
};

export default GlowingCircle;
